<!--
 * @Author: wzc
 * @Date: 2021-06-18 10:39:41
 * @LastEditors: wzc
 * @LastEditTime: 2021-06-02 16:48:31
-->
<template>
  <div class="head_title" v-if="title" v-text="title"></div>
</template>
<script>
export default {
  name: 'head_title',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
}
</script>
<style lang="scss" scoped>
.head_title {
  padding-top: 14px;
  padding-bottom: 18px;
  font-size: unquote('14px');
  color: #333333;
  font-weight: bold;
}
</style>
